import React, { HTMLProps } from 'react';
import { Container } from 'react-bootstrap';

import cx from 'classnames';

import s from './DonationCampaignBannerSection.module.scss';

interface DonationCampaignBannerSectionProps extends HTMLProps<HTMLElement> {
  backgroundImageURL?: string;
  bannerImageAlt?: string;
  backgroundImageMobileURL?: string;
}
const DonationCampaignBannerSection: React.FC<
  DonationCampaignBannerSectionProps
> = ({
  bannerImageAlt,
  backgroundImageURL,
  backgroundImageMobileURL,
  children,
  className,
  ...props
}) => {
  return (
    <>
      <style jsx>
        {`
          .banner-image {
            background-image: ${backgroundImageURL
              ? `url(${backgroundImageURL})`
              : 'none'};
          }
          @media (max-width: 768px) {
            .banner-image {
              background-image: url(${backgroundImageMobileURL ||
              backgroundImageURL});
            }
          }
        `}
      </style>
      <section
        className={cx(s['background-image'], 'banner-image', className)}
        role="img"
        aria-label={bannerImageAlt}
        {...props}
      >
        <Container className={s['banner-container']}>{children}</Container>
      </section>
    </>
  );
};

export default DonationCampaignBannerSection;
